import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { MilesByStateData } from 'interfaces/ISummaryReport'
import { getMilesByStateTableColumns } from './milesByStateTableData'
import strings from 'strings'
import { ScrollableTable } from 'components'

const r = strings.SUMMARY_REPORT.RADIUS_OF_OPERATION

interface IMilesByStateTableProps {
  loading: boolean
  hasData: boolean
  data: MilesByStateData[]
}

const MilesByStateTable: React.FC<IMilesByStateTableProps> = ({
  loading,
  hasData,
  data,
}) => {
  return (
    <Box
      sx={{
        height: 368,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {loading ? (
        <CircularProgress size={30} />
      ) : !hasData ? (
        <Typography variant="body1" color="text.secondary">
          {r.NO_DATA}
        </Typography>
      ) : (
        <ScrollableTable
          data={data}
          columns={getMilesByStateTableColumns()}
          height={368}
        />
      )}
    </Box>
  )
}

export default MilesByStateTable
